export default __webpack_public_path__ + "static/media/PG.4b97cebf.svg";